(function () {
    setInterval(function(){
        if (navigator.onLine) {
            $('body').removeClass('offline')
          } else {
            $('body').addClass('offline')
          }
    },10000);
            
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
    
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
    
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $('img').each(function(){
        imageDimenstions($(this));
    })

    function imageDimenstions(e){
        var width = e.width();
        var height = e.height();
        e.attr('width',width);
        e.attr('height',height);
    }

    $(window).scroll(function(){
        
        $('.content_block_item_wrapper').each(function(){
            if($(this).isInViewport()){
                $(this).addClass('is-inview');
            }
        })

        $('.list_element_homepage_wrapper--main').each(function(){
            if($(this).isInViewport()){
                $(this).addClass('is-inview');
            }
        })

        $('img').on('load',function(){
            imageDimenstions($(this));
        })

    })
    
})();  

window.onbeforeunload = function() {
    $('body').hide();
    window.scrollTo(0,0);
}

if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}
